import {
  Component,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlycaDataService } from '../../../services/plyca.service';

import { UIService } from '../../ui.service';
import { DossierService } from '../dossier.service';
import {
  ExpenseManagementDTO,
  ExpenditurePhaseDTO,
  ExpenseManagementLineDTO,
  ExpenseDocumentLinkDTO,
  ExpenseTaskStates,
  ExpenseManagementLineCPDTO,
  TypeExpense,
  ActionParameterDefinitionDTO,
  AccountingDocumentDTO,
  SearchActionResultDTO,
  ActionResultDTO,
  ProcessRegisterInfoDTO
} from '../../api/plyca-dtos-v2';
import {
  getSimpleIdentifierFromString,
  DivisionDTO,
  DocumentStateDTO,
  TaskDTO,
  SearchResultDTO,
  LinkedActionsDTO,
  DocumentDTO,
  DocumentVersionDTO,
  LoginResponse,
  ProcedureDTO
} from '../../api/plyca-dtos';
import { DocumentService } from '../../documents/document.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { throwError, forkJoin, Observable, of, EMPTY, from, concat } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { DatePipe } from '@angular/common';
import { TaskHandler } from '../../tasks/TaskHandler';
import { AccountingDocumentTypesComponent } from './accountingDocumentTypes.component';
import { AccountingDocumentComponent } from './accountingDocument.component';
import { catchError, map, finalize, tap, switchMapTo, switchMap, mergeMap, take, last } from 'rxjs/operators';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { TranslateService } from '@ngx-translate/core';
import * as lodash from 'lodash';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { generateRandomIdentifier } from '../../ui.service';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { SearchConfig } from '../../api/contract-notice-dto';
import { AppConfiguration } from '../../conf/app.configuration';
import { UserService } from '../../user.service';
import { PasswordData } from '../../password/model/password.model';
import { PasswordComponent } from '../../password/component/password.component';
import { SET_USEREXTRAPARAM } from '../../store/user';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { SessionInfo } from '../../api/UserPrefs-dto';


@Component({
  selector: 'accounting',
  templateUrl: 'accounting.template.html',
  providers: [DatePipe, DialogService]
})
export class accountingViewComponent extends TaskHandler
  implements AfterContentInit, OnDestroy {
  loaded = false;
  dossierId: string;
  dossier: any;

  documentos: ExpenseManagementLineDTO[] = [];
  expenseLines: ExpenseManagementLineDTO[];
  filteredDocuments: ExpenseManagementLineDTO[] = [];
  phases: Array<ExpenditurePhaseDTO> = [];
  originPhases: Array<ExpenditurePhaseDTO> = [];
  divisions: Array<DivisionDTO> = [];
  contracts = [];
  executionFolders = [];
  selectedContract: any;
  selectedExecutionFolders: any;
  years = [];
  selectedYear: any;
  cp = [];
  selectedCP: any;
  processedTask = false;
  taskFilterCreated = false;



  public TIPO_IMPORTE_TOTAL = 0;
  public TIPO_IMPORTE_POSTED = 1;
  public TIPO_IMPORTE_PENDING = 2;
  public TRAMITACIONANTICIPADA_desc = 'Tramitación anticipada';
  public CORRIENTE_desc = 'Corriente';
  public FUTURO_desc = 'Futuro';
  actionService: any;
  public windowHash: string;
  private tokenSistemaContable: string

  constructor(
    protected appConfig: AppConfiguration,
    public plycaService: PlycaDataService,
    public dialogService: DialogService,
    private headerActionsService: HeaderActionsService,
    public configuration: Configuration,
    public activatedRoute: ActivatedRoute,
    protected translate: TranslateService,
    private plycaErrorHandler: PlycaErrorHandler,
    public documentService: DocumentService,
    public uiService: UIService,
    public dossierService: DossierService,
    public waitService: WaitLoadingService,
    private store: Store<AppState>
  ) {
    super();

    /*  this.documentService = ServiceLocator.injector.get(DocumentService);
      this.uiService = ServiceLocator.injector.get(UIService);
      this.dossierService = ServiceLocator.injector.get(DossierService);
      this.waitService = ServiceLocator.injector.get(WaitLoadingService);
          this.userService = ServiceLocator.injector.get(UserService);*/
    this.windowHash = generateRandomIdentifier();

    // this.datePipe = ServiceLocator.injector.get(DatePipe);
  }

  ngOnInit(): void {
    let cliente = this.appConfig.getValue('cliente');
    // TODO
    // cliente = 'CABGC';
    if ('CABGC' === cliente) {
      this.subscribe(this.store.select('user'),
        (sesInfo: SessionInfo) => {
          this.tokenSistemaContable = sesInfo.extraParams ? sesInfo.extraParams['token'] : undefined;
        });
    }

    let objectType = 'USER';
  }

  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.headerActionsService.clearActions();
    this.subscribe(this.headerActionsService
      .addAction('Actualizar', 'fas fa-lg fa-sync-alt', 'btn-secondary', true),
      () => {
        this.load();
      });

    if (this.task) {
      if (this.appConfig.getValue('accounting.import')) {
        this.headerActionsService.addDivider();
        this.subscribe(this.headerActionsService
          .addAction(
            'Importar',
            'fas fa-lg fa-check',
            'btn-primary',
            true
          ),
          () => {
            this.importar();
          });
      }
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService
        .addAction(
          'General.accept',
          'fas fa-lg fa-check',
          'btn-primary',
          true
        ),
        () => {
          this.volver();
        });
    } else {
      this.subscribe(this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        ),
        () => {
          this.volver();
        });
    }

    if (this.task !== undefined) {
      this.dossierId = this.task.division.project.identifier;
      this.load();
    } else {
      this.subscribe(this.activatedRoute.params, params => {
        this.dossierId = params['id'];
        this.load();
      });
    }
  }

  generalActions() {
    throw new Error('Method not implemented.');
  }
  openModalAction(action: any, task: TaskDTO, doc: AccountingDocumentDTO) {
    let config: DynamicDialogConfig = {
      header: action.name,

      width: '70%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }


    };
    config['action'] = action;

    action.parameters.find((a) => a.name === 'CLOSE_TAXYEAR_TAXYEAR').value = doc.startYear;
    action.parameters.find((a) => a.name === 'CLOSE_TAXYEAR_TAXYEAR').editable = false;
    action.parameters.find((a) => a.name === 'CLOSE_TAXYEAR_CAPTURENUMBER').value = doc.captureNumber;
    action.parameters.find((a) => a.name === 'CLOSE_TAXYEAR_CAPTURENUMBER').editable = false;
    action.parameters.find((a) => a.name === 'CLOSE_TAXYEAR_CAPTUREDATE').value = doc.captureDate;
    action.parameters.find((a) => a.name === 'CLOSE_TAXYEAR_CAPTUREDATE').editable = false;
    return this.dialogService.open(ActionsProcessComponent, config);
  }
  reload() {
    throw new Error('Method not implemented.');
  }

  /************************************ IMPORTAR LEGANES y CABILDO GC ******************************************* */
  public rowFnImportar(row: SearchResultDTO) {

    let accountingDocument: AccountingDocumentDTO = row.singleValue;
    // CABGC
    let cliente = this.appConfig.getValue('cliente');
    // TODO
    // cliente = 'CABGC'
    if ('CABGC' === cliente) {
      if (row?.formFilters?.INTEGRATIONEXPENSEDOCUMENTS?.CUD) {
        let cud = row.formFilters.INTEGRATIONEXPENSEDOCUMENTS.CUD;
        // Si el filtro tiene establecido el CUD ese es el que prevalece, aunq el servicio haya devuelto un CUD
        if (accountingDocument.document) {
          if (accountingDocument.document.currentVersion) {
            accountingDocument.document.currentVersion.externalIdentifier = cud;
          } else {
            accountingDocument.document.currentVersion = new DocumentVersionDTO();
            accountingDocument.document.currentVersion.externalIdentifier = cud;
          }
        } else {
          accountingDocument.document = new DocumentDTO();
          accountingDocument.document.currentVersion.externalIdentifier = cud;
        }
      }
    }
    return this.addExpenseDocument(accountingDocument);
  }

  doLogin(data: PasswordData): Observable<string> {
    let url = this.configuration.LOGIN_EXPENSE_DOCUMENT_SERVICE_URL;
    let loginRequest = { externalUser: data.userId, password: data.password }
    return this.plycaService.simplePost(url, loginRequest).pipe(
      map((loginResponse: LoginResponse) => loginResponse.accessToken)
    );
  }

  public importar(): void {
    let cliente = this.appConfig.getValue('cliente');
    // TODO
    // cliente = 'CABGC';
    if ('CABGC' === cliente && this.tokenSistemaContable == null) {
      // Abrir ventana de login
      let configLogin: DynamicDialogConfig = {
        width: '50%',
        style: { overflow: 'scroll', 'max-height': '60%' },
        header: 'Login sistema contable',
        data: {
          function: this.doLogin.bind(this)
        }
      };
      let passwordRef = this.dialogService.open(PasswordComponent, configLogin);
      passwordRef.onClose.pipe(take(1)).subscribe((resultDoLoginFn: string) => {
        // actualizar parametro extendido de usuario
        this.store.dispatch(SET_USEREXTRAPARAM({ key: 'token', value: resultDoLoginFn }));
        if (resultDoLoginFn !== undefined) {
          this.openSearchImportar();
        }
      });
    } else {
      this.openSearchImportar();
    }
  }

  private openSearchImportar() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    let completedResult = true;
    let autoSearch = false;
    let showWait = true;
    let searchConfig = new SearchConfig();
    searchConfig.multiSelection = true;
    // CABGC
    let cliente = this.appConfig.getValue('cliente');
    // TODO
    // cliente = 'CABGC'
    if ('CABGC' === cliente) {
      searchConfig.multiSelection = false;
      if (this.task && this.task.work.divisionIdentifier) {

        let param1 = new ActionParameterDefinitionDTO();
        param1.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.TOKEN';

        param1.value = this.tokenSistemaContable;

        console.log('******************** login CABGC *******************');
        console.log('param0.identifier: ' + param1.identifier);
        console.log('param0.value: ' + param1.value);
        console.log('****************************************************');

        parametersURL.push(param1);


        let param2 = new ActionParameterDefinitionDTO();
        param2.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.PROPUESTAID';
        param2.value = this.dossierId.substring(0, 4) + '/' + this.dossierId.substring(4);
        parametersURL.push(param2);

        let param3 = new ActionParameterDefinitionDTO();
        param3.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.DIVISION';
        param3.value = this.task.work.divisionIdentifier; // Esta definido como NUMERIC en el buscador y en servidor espera un Short
        parametersURL.push(param3);

        let param4 = new ActionParameterDefinitionDTO();
        param4.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.NUMTRAMITE';
        // Esta definido como NUMERIC en el buscador y en servidor espera un Short
        let numTramite = Number(getSimpleIdentifierFromString(this.task.procedure.identifier));
        param4.value = numTramite;
        parametersURL.push(param4);
        // FIN CABGC
      }
    } else {
      searchConfig.multiSelection = true;
      if ('UVAL' === cliente && this.task && this.task.work.divisionIdentifier) {
        let param1 = new ActionParameterDefinitionDTO();
        param1.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.PROPUESTAID';
        param1.value = this.dossierId.substring(0, 4) + '/' + this.dossierId.substring(4);
        parametersURL.push(param1);

        let param2 = new ActionParameterDefinitionDTO();
        param2.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.DIVISION';
        param2.value = this.task.work.divisionIdentifier; // Esta definido como NUMERIC en el buscador y en servidor espera un Short
        parametersURL.push(param2);

        let param3 = new ActionParameterDefinitionDTO();
        param3.identifier = 'INTEGRATIONEXPENSEDOCUMENTS.PHASES';
        let newExpenseDocumetTypes = this.task.work.context.configurations['newExpenseDocumetTypes'].value;
        // Por problemas en searchGenericComponent.getNestedProperty, mandamos un array si los los valores ->  [,,,,,,,] con doble encoding
        /*if (ret && typeof ret === 'object') {
          if (Array.isArray(ret)) {
            // Lista de valores separados por comas
            ret = ret.map(obj => { return getSimpleIdentifierFromString(obj.identifier) }).toString();
            ret = encodeURIComponent(ret);
          } else {
            ret = getSimpleIdentifierFromString(ret.identifier);
          }
        }*/
        const separator = ';';
        param3.value = newExpenseDocumetTypes.join(separator);

        parametersURL.push(param3);
      }
    }

    searchConfig.actionCfg = {
      rowFn: this.rowFnImportar.bind(this),
      //preExcuteFn: this.postExcuteFnImportar.bind(this)
      //preExcuteFn: this.myFunctionpreExcuteImportar.bind(this),
      //objectType: 'PROCUREMENTPROJECT',
      //idName: 'PROPUESTAID',
      //action: 'LEGANES_CHANGE_STATUS_SITUATION_CLOSE_TAX_YEAR',
      //paramNames: ['EXPEDIENTEID', 'ANIOPRESUPUESTO', 'IDPROCESO']
    };

    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONEXPENSEDOCUMENTS',
      autoSearch,
      parametersURL,
      completedResult,
      searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    config['showWait'] = showWait;

    const ref = this.dialogService.open(searchGenericComponent, config);
    this.subscribe(ref.onClose,
      () => {
        this.taskLoad();
      },
      (error) => {
        console.log(error);
      });
  }

  private addExpenseDocument(doc: AccountingDocumentDTO): Observable<any> {
    console.log('addExpenseDocument ', doc);
    if (doc) {
      // TODO
      // ¿Qué pasa cuando no sea tarea?
      if (this.task && this.task.work.divisionIdentifier) {
        let division = new DivisionDTO();
        division.identifier = this.task.work.divisionIdentifier + '<>' + this.dossierId;
        doc.division = division;
      }

      let url = this.configuration.IMPORT_EXPENSE_DOCUMENT_SERVICE_URL;

      // Es necesario establecer el task, en servidor se requiere del número de trámite a la hora de grabar
      // el documento contable!!
      doc.task = {} as TaskDTO;
      doc.task.identifier = this.task.identifier;
      doc.task.procedure = {} as ProcedureDTO;
      doc.task.procedure.identifier = this.task.procedure.identifier;

      doc.accountingSystemToken = this.tokenSistemaContable;
      return this.plycaService.insert<AccountingDocumentDTO>(url, doc).pipe(
        map((result: AccountingDocumentDTO) => {
          let actionResult = new SearchActionResultDTO();
          actionResult.success = true;
          actionResult.objectResult = result;
          return actionResult;
        })
      );
    }
    return EMPTY;
  }
  /* *********************************** FIN IMPORTAR LEGANES ************************************************* */
  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  private load(showWait = true): void {
    if (showWait) {
      this.waitService.startWaiting();
    }
    this.loaded = false;
    let documentObs: Observable<ExpenseManagementDTO>;
    if (this.task !== undefined && this.task.work !== undefined) {
      console.log('NO RECARGA LA TAREA DE GESTION DEL GASTO:', this.dossierId);
      documentObs = of(this.task.work.expenseManagementDTO);
    } else {
      console.log('CARGANDO GASTO DEL EXPEDIENTE:', this.dossierId);
      documentObs = this.plycaService.get<ExpenseManagementDTO>(this.configuration.EXPENSE_MANAGEMENTS_SERVICE_URL, this.dossierId);
    }
    this.subscribe(forkJoin([
      this.plycaService.query<ExpenditurePhaseDTO>(
        this.configuration.EXPENDITURE_PHASE_SERVICE_URL
      ),
      this.plycaService.getDossierDivisions(this.dossierId),
      documentObs
    ]), result => {
      // LIMPIAR FILROS
      this.contracts = [];
      this.years = [];
      this.cp = [];

      // 1. recuperar información del expediente
      this.phases = [];
      if (result[0] && result[0].content) {
        this.phases = result[0].content;

        // Llamamos al pathdto que inicializa las variables para calcular los importes totales
        this.phases.forEach(p => p = ExpenditurePhaseDTO.patchDTO(p));
        this.originPhases = lodash.cloneDeep(this.phases);
      }

      // 2. listado de divisiones
      if (result[1]) {
        this.divisions = result[1].content;
      }

      // 3. listado de documentos contables
      this.documentos = [];
      if (result[2] && result[2].listExpenseLine) {
        this.expenseLines = result[2].listExpenseLine;
        this.documentos = this.processListExpenseLine(result[2].listExpenseLine);
      }
      this.filteredDocuments = this.documentos;

      if (this.divisions) {
        let awardDivisionss = this.divisions.filter(division => division.documentClass.identifier === '02001');
        if (awardDivisionss && awardDivisionss.length > 0) {
          awardDivisionss.forEach(division => {
            this.contracts.push({
              label: division.name,
              value: division
            });
          });
        }
      }

      // Añadir opciones vacías al principio del modelo (si hay mas de 1 elemento)
      if (this.contracts.length > 0) {
        this.contracts.unshift({ label: 'Todos', value: -1 });
        // EN APERTURA DESDE TAREA, SELECCIONAR EL CONTRATO QUE LLEGUE COMO PARAMETRO
        if (!this.taskFilterCreated && this.task && this.task.work && this.task.work.divisionIdentifier) {
          let workDivisionIdentifier = this.task.work.divisionIdentifier;
          let divisionFilter;
          if (this.task.work.divisionIdentifier !== '0') {
            //Se decide no seleccionar la carpeta de ejecución cuya division en la de la tarea. De esta forma, el acance sera menos
            //this.selectedExecutionFolders = this.divisions.find(div => getSimpleIdentifierFromString(div.identifier) === workDivisionIdentifier && div.documentClass?.identifier === '02103');
            //console.log('CARPETA DE EJECUCION SELECCIONADA: ', this.selectedExecutionFolders);
            divisionFilter = getSimpleIdentifierFromString(this.task.work.award.division.identifier);
          } else {
            divisionFilter = workDivisionIdentifier;
          }
          this.selectedContract = this.divisions.find(div => getSimpleIdentifierFromString(div.identifier) === divisionFilter);
          console.log('CONTRATO SELECCIONADO: ', this.selectedContract);

        }
      } else if (this.contracts.length === 1) {
        this.selectedContract = this.contracts[0].value;
      }

      this.setExecutionFolders();


      if (this.years.length > 1) {
        this.years.unshift({ label: 'Todos', value: -1 });
        if (!this.taskFilterCreated && this.task && this.task.work && this.task.work.exercise) {
          this.selectedYear = this.task.work.exercise;
        }
      }
      this.taskFilterCreated = true;

      if (this.cp.length > 1) {
        this.cp.unshift({ label: 'Todos', value: -1 });
      }
      // APLICAR FILTROS PARA MOSTRAR LOS DOCUMENTOS ADECUADOS Y CALCULAR LOS IMPORTE
      this.filter();

      this.loaded = true;
      if (showWait) {
        this.waitService.cancelWaiting();
      }
    });
  }

  setExecutionFolders() {
    this.executionFolders = [];
    const executionDivisions = this.divisions.filter(division => this.isExecution(division) && division.parent !== undefined
      && division.parent.identifier === this.selectedContract?.identifier);
    if (executionDivisions && executionDivisions.length > 0) {
      executionDivisions.forEach(division => {
        this.executionFolders.push({
          label: division.name,
          value: division
        });
      });
      if (this.executionFolders) {
        this.executionFolders.unshift({ label: 'Todas', value: -1 });
      }
    }
  }

  processListExpenseLine(_documents: ExpenseManagementLineDTO[]): ExpenseManagementLineDTO[] {
    // 1. SEPARAR EN DOCUMENTOS CORRIENTE FUTURO ANTICIPADA
    let processedDocuments = this.processDocuments(_documents);

    // 2. Ordenar documentos por fecha: TODO: Pasar a servidor?????
    this.sortDocuments(processedDocuments);

    // 3. CARGAR FILTROS EN FUNCION DE LOS DOCUMENTOS
    this.loadFilters(processedDocuments);

    return processedDocuments;
  }

  processDocuments(_documents: ExpenseManagementLineDTO[]): ExpenseManagementLineDTO[] {
    let processedDocumentList: ExpenseManagementLineDTO[] = [];
    _documents.forEach(doc => {
      // CALCULAR LA DESCRIPCION A MOSTRAR DEL DOCUMENTO
      doc['_description'] = doc.documentClassDTO.abbreviation;

      doc['_description'] += doc.sign !== 0 ? ' /' : '';

      if (doc.accountingDocumentType !== doc.documentClassDTO.abbreviation) {
        doc['_description'] += ' ' + doc.accountingDocumentType;
      }

      // Si el documento tiene es plurianual (tramAnticipada, corriente, futuro) sale una vez por cada una de las opciones.
      if (TypeExpense[doc.expenseAmount.typeExpense] === TypeExpense.EARLYPROCESSINGAMOUNT) {
        let _doc = lodash.cloneDeep(doc);
        _doc.CP = ExpenseManagementLineCPDTO.TRAMITACIONANTICIPADA;

        if (doc.sign === 1) {
          _doc['_amount'] = doc.expenseAmount.earlyProcessingAmount * (-1);
        } else {
          _doc['_amount'] = doc.expenseAmount.earlyProcessingAmount;
        }

        processedDocumentList.push(_doc);

        if (!this.cp.some(x => x.value === ExpenseManagementLineCPDTO.TRAMITACIONANTICIPADA)) {
          this.cp.push({ label: this.TRAMITACIONANTICIPADA_desc, value: ExpenseManagementLineCPDTO.TRAMITACIONANTICIPADA });
        }
      }
      if (TypeExpense[doc.expenseAmount.typeExpense] === TypeExpense.CURRENTAMOUNT
        || TypeExpense[doc.expenseAmount.typeExpense] === TypeExpense.CURRENTFUTUREAMOUNT) {
        let _doc = lodash.cloneDeep(doc);
        _doc.CP = ExpenseManagementLineCPDTO.CORRIENTE;

        if (doc.sign === 1) {
          _doc['_amount'] = doc.expenseAmount.currentAmount * (-1);
        } else {
          _doc['_amount'] = doc.expenseAmount.currentAmount;
        }

        processedDocumentList.push(_doc);

        if (!this.cp.some(x => x.value === ExpenseManagementLineCPDTO.CORRIENTE)) {
          this.cp.push({ label: this.CORRIENTE_desc, value: ExpenseManagementLineCPDTO.CORRIENTE });
        }
      }
      if (TypeExpense[doc.expenseAmount.typeExpense] === TypeExpense.FUTUREAMOUNT
        || TypeExpense[doc.expenseAmount.typeExpense] === TypeExpense.CURRENTFUTUREAMOUNT) {
        let _doc = lodash.cloneDeep(doc);
        _doc.CP = ExpenseManagementLineCPDTO.FUTURO;

        if (doc.sign === 1) {
          _doc['_amount'] = doc.expenseAmount.futureAmount * (-1);
        } else {
          _doc['_amount'] = doc.expenseAmount.futureAmount;
        }

        processedDocumentList.push(_doc);

        if (!this.cp.some(x => x.value === ExpenseManagementLineCPDTO.FUTURO)) {
          this.cp.push({ label: this.FUTURO_desc, value: ExpenseManagementLineCPDTO.FUTURO });
        }
      }
    });
    return processedDocumentList;
  }

  calculateTotalAmounts() {
    // RESET DE IMPORTES PARA EMPEZAR EL CALCULO
    this.clearAmounts();

    // Cuando llega aqui los documentos estan desdoblados para corriente/futuro/tramAntipada.
    // Se incluye un control para evitar que se sumen los importes varias veces
    let processedDoc: Array<string> = [];
    // ACUMULAR IMPORTE POR FASE PARA EL PIE DE LA TABLA (CON LOS DOCUMENTOS FILTRADOS)
    this.filteredDocuments.forEach(doc => {
      if (!processedDoc.some(id => id === doc.documentDTO.identifier) && doc.expenditurePhases) {
        doc.expenditurePhases.forEach(docPhase => {
          let phase = this.phases.find(
            p => p.identifier === docPhase.identifier
          );
          if (doc.postedState) {
            phase.totalPostedAmount += doc.sign === 1 ? doc.expenseAmount.totalAmount * (-1) : doc.expenseAmount.totalAmount;
            phase.currentPostedAmount += doc.sign === 1 ? doc.expenseAmount.currentAmount * (-1) : doc.expenseAmount.currentAmount;
            phase.earlyProcessingPostedAmount += doc.sign === 1 ? doc.expenseAmount.earlyProcessingAmount * (-1) : doc.expenseAmount.earlyProcessingAmount;
            phase.futurePostedAmount += doc.sign === 1 ? doc.expenseAmount.futureAmount * (-1) : doc.expenseAmount.futureAmount;
          }
          phase.totalAmount += doc.sign === 1 ? doc.expenseAmount.totalAmount * (-1) : doc.expenseAmount.totalAmount;
          phase.currentAmount += doc.sign === 1 ? doc.expenseAmount.currentAmount * (-1) : doc.expenseAmount.currentAmount;
          phase.earlyProcessingAmount += doc.sign === 1 ? doc.expenseAmount.earlyProcessingAmount * (-1) : doc.expenseAmount.earlyProcessingAmount;
          phase.futureAmount += doc.sign === 1 ? doc.expenseAmount.futureAmount * (-1) : doc.expenseAmount.futureAmount;
        });
      }
      processedDoc.push(doc.documentDTO.identifier);
    });

  }

  calculatePendingAmounts() {
    // CALCULO DE SALDOS PENDIENTE
    this.phases.forEach((phase, idx) => {
      if (idx !== this.phases.length - 1) {
        let nextPhase = this.phases[idx + 1];
        phase.currentPendingAmount = phase.currentPostedAmount - nextPhase.currentAmount;
        phase.totalPendingAmount = phase.totalPostedAmount - nextPhase.totalAmount;
        phase.earlyProcessingPendingAmount = phase.earlyProcessingPostedAmount - nextPhase.earlyProcessingAmount;
        phase.futurePendingAmount = phase.futurePostedAmount - nextPhase.futureAmount;
      } else {
        phase.currentPendingAmount = phase.currentPostedAmount - phase.currentAmount;
        phase.totalPendingAmount = phase.totalPostedAmount - phase.totalAmount;
        phase.earlyProcessingPendingAmount = phase.earlyProcessingPostedAmount - phase.earlyProcessingAmount;
        phase.futurePendingAmount = phase.futurePostedAmount - phase.futureAmount;
      }
    });
  }

  clearAmounts() {
    this.phases.forEach((phase, idx) => {
      phase.totalPostedAmount = 0;
      phase.currentPostedAmount = 0;
      phase.earlyProcessingPostedAmount = 0;
      phase.futurePostedAmount = 0;

      phase.totalAmount = 0;
      phase.currentAmount = 0;
      phase.earlyProcessingAmount = 0;
      phase.futureAmount = 0;

      phase.currentPendingAmount = 0;
      phase.totalPendingAmount = 0;
      phase.earlyProcessingPendingAmount = 0;
    });
  }

  sortDocuments(_documents: ExpenseManagementLineDTO[]) {
    return _documents.sort((a, b) => {
      if (a.documentDTO.creationDate >= b.documentDTO.creationDate) {
        return 1;
      } else {
        return -1;
      }
    });
  }

  loadFilters(_documents: ExpenseManagementLineDTO[]) {
    _documents.forEach(doc => {
      // 1. CARGAR EJERCICIOS
      if (!this.years.some(x => x.value === doc.exerciseYear)) {
        this.years.push({ label: doc.exerciseYear, value: doc.exerciseYear });
      }
      // 2 CARGAR CONTRATOS
      // TEMPORAL: Parcheamos docdivision y docDivisionParent
      doc.documentDTO.entity.division = this.divisions.find(div => div.identifier === doc.documentDTO.entity.division.identifier);
      if (doc.documentDTO.entity.division.parent) {
        doc.documentDTO.entity.division.parent = this.divisions.find(
          div => div.identifier === doc.documentDTO.entity.division.parent.identifier
        );
      }
    });
  }

  getContractDivision(docDivision: DivisionDTO) {
    if (getSimpleIdentifierFromString(docDivision.identifier) === '0') {
      return;
    } else if (this.isContract(docDivision)) {
      return docDivision;
    } else if (docDivision.parent && this.isContract(docDivision.parent)) {
      // Si la division padre es un contrato lo devolvemos
      return docDivision.parent;
    } else {
      return;
    }
  }

  isContract(division: DivisionDTO) {
    return division.documentClass.identifier === '02001'
  }

  isExecution(division: DivisionDTO) {
    return division.documentClass.identifier === '02103'
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  filter(evt?: any, isContractFilter?: Boolean, isExecutionFolderFilter?: boolean) {
    let e = evt?.value;
    let docsTmp = this.documentos;

    if (isContractFilter) { // Cargamos las carpetas de ejecucion del contrato seleccionado
      this.setExecutionFolders();
      this.selectedExecutionFolders = -1;
    }
    // 1. FILTRO POR CARPETA DE EJECUCION Y CONTRATO SELECCIONADO
    let filteredExecutionFolders = false;
    if (this.selectedExecutionFolders !== undefined && this.selectedExecutionFolders?.value !== -1) {
      //FILTRO POR CARPETA DE EJECUCION
      if (this.selectedExecutionFolders?.value?.identifier && getSimpleIdentifierFromString(this.selectedExecutionFolders?.value?.identifier) !== '0') {
        filteredExecutionFolders = true;
        console.log('Filtrando por carpeta de ejecución y sus padres recursivamente:', this.selectedExecutionFolders);
        docsTmp = docsTmp.filter(
          x => {
            let contractDivisionDoc = this.getContractDivision(x.documentDTO.entity.division);
            let isDocDossierCarpet = getSimpleIdentifierFromString(x.documentDTO.entity.division.identifier) === '0';
            let isDocContractCarpet = contractDivisionDoc?.identifier === this.selectedContract.identifier && !this.isExecution(x.documentDTO.entity.division);
            let isDocExecutionCarpet = getSimpleIdentifierFromString(x.documentDTO.entity.division.identifier) === getSimpleIdentifierFromString(this.selectedExecutionFolders.value.identifier);
            let isDocFilter = isDocDossierCarpet || isDocContractCarpet || isDocExecutionCarpet;
            return isDocFilter;
          }
        );
      }
    }
    if (!filteredExecutionFolders && this.selectedContract !== undefined && this.selectedContract !== -1) {
      //CONTRATO SELECCIONADO
      if (this.selectedContract?.identifier && getSimpleIdentifierFromString(this.selectedContract.identifier) !== '0') {
        console.log('Filtrando por contracto:', this.selectedContract);
        docsTmp = docsTmp.filter(
          x => {
            let contractDivision = this.getContractDivision(x.documentDTO.entity.division);
            return (getSimpleIdentifierFromString(x.documentDTO.entity.division.identifier) === '0' ||
              (contractDivision && contractDivision.identifier === this.selectedContract.identifier));
          }
        );
      }
    }

    // 2. FILTRO POR EJERCICIO
    if (this.selectedYear !== undefined && this.selectedYear !== -1) {
      let filteredDocsTmp = docsTmp.filter(x => x.exerciseYear === this.selectedYear);
      // Hacemos porque a la hora de abrir la tarea se establece por defecto el ejercicio de la división, si éste
      // tuviera un ejercicio en el cual todavía no tenemos documentos contables, debemos seleccionar en el combo de
      // ejercicio la opción TODOS, por tanto, mostrar los documentos contables sin fitrar por ejercicio.
      if (filteredDocsTmp.length > 0) {
        docsTmp = filteredDocsTmp;
      }
    }

    // 3. FILTRO POR TRAM_ANTICIPADA/CORRIENTE/FUTURO
    if (this.selectedCP !== undefined && this.selectedCP !== -1) {
      docsTmp = docsTmp.filter(_doc => _doc.CP === this.selectedCP);
    }

    // Importante, volver a resetear las fases
    this.phases = lodash.cloneDeep(this.originPhases);

    this.filteredDocuments = docsTmp;

    this.calculateTotalAmounts();

    // FILTRAR FASES SIN DOCUMENTOS
    // Comentamos esto porque tenemos dos problemas:
    // - Si el total de la fase es 0 no se muestra la fase (Podemos tener un A por 100 y un A\ por 100)
    // - El calculo de los totales no es correcto al faltar una fase
    // this.filterEmptyPhases();

    // EL cálculo de saldos perndientes queremos que se haga en base a las fases mostradas (Aquellas que solo tienen importes)
    this.calculatePendingAmounts();
  }

  filterEmptyPhases() {
    // Limpiamos
    this.phases = this.phases.filter(phase => phase.totalAmount > 0);
  }

  getStatusTaskColor(expenseTaskStates: ExpenseTaskStates): string {
    try {
      if (expenseTaskStates === ExpenseTaskStates.PENDING) {
        return 'danger';
      } else if (expenseTaskStates === ExpenseTaskStates.COMPLETED) {
        return 'success';
      }
    } catch (ex) {
    }
    return '';
  }

  getBgStatusColor(doc) {
    let color = this.getStatusTaskColor(doc.expenseTaskStatus);
    if (color) {
      color = 'bg-' + color;
    }
    return color;
  }

  getTextStatusColor(doc) {
    let color = this.getStatusTaskColor(doc.expenseTaskStatus);
    if (color) {
      color = 'badge badge-' + color;
    }
    return color;
  }

  getStatusColor(state: DocumentStateDTO): string {
    let ret = 'badge ';
    try {
      let stateId = getSimpleIdentifierFromString(state.type.identifier);
      if (stateId === 'ANULADO') {
        ret += 'badge-danger';
      } else if (stateId === '1') {
        // 'Cumplimentado') {
        ret += 'badge-secondary';
      } else if (stateId === '2') {
        // 'En reparacion') {
        ret += 'badge-warning';
      } else {
        ret += 'badge-secondary';
      }
      return ret;
    } catch (ex) {
      return '';
    }
  }

  getImportePhase(phase: ExpenditurePhaseDTO, _TIPO_IMPORTE: number) {
    if (this.selectedCP === undefined || this.selectedCP === -1) {
      if (_TIPO_IMPORTE === this.TIPO_IMPORTE_TOTAL) {
        return phase.totalAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_PENDING) {
        return phase.totalPendingAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_POSTED) {
        return phase.totalPostedAmount;
      }
    } else if (this.selectedCP === ExpenseManagementLineCPDTO.TRAMITACIONANTICIPADA) {
      if (_TIPO_IMPORTE === this.TIPO_IMPORTE_TOTAL) {
        return phase.earlyProcessingAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_PENDING) {
        return phase.earlyProcessingPendingAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_POSTED) {
        return phase.earlyProcessingPostedAmount;
      }
    } else if (this.selectedCP === ExpenseManagementLineCPDTO.CORRIENTE) {
      if (_TIPO_IMPORTE === this.TIPO_IMPORTE_TOTAL) {
        return phase.currentAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_PENDING) {
        return phase.currentPendingAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_POSTED) {
        return phase.currentPostedAmount;
      }
    } else if (this.selectedCP === ExpenseManagementLineCPDTO.FUTURO) {
      if (_TIPO_IMPORTE === this.TIPO_IMPORTE_TOTAL) {
        return phase.futureAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_PENDING) {
        return phase.futurePendingAmount;
      } else if (_TIPO_IMPORTE === this.TIPO_IMPORTE_POSTED) {
        return phase.futurePostedAmount;
      }
    }
    return;
  }

  isDocInPhase(
    doc: ExpenseManagementLineDTO,
    phase: ExpenditurePhaseDTO
  ): boolean {
    return (
      doc.expenditurePhases && // TODO: REMOVE
      doc.expenditurePhases.some(
        docPhase => phase.identifier === docPhase.identifier
      )
    );
  }

  openDocument(doc) {
    // this.route.navigate(['documentViewer', doc.documentDTO.identifier]);
    let config: DynamicDialogConfig = {
      header: doc.name ? doc.name : (doc.documentDTO ? doc.documentDTO.name : ''),
      width: '97%',
      styleClass: 'searchStyle'
    };

    config.data = {
      'id': doc.documentDTO.identifier

    }
    this.waitService.startWaiting();
    let modal = this.dialogService.open(documentViewerComponent, config);
    this.subscribe(modal.onClose);
  }


  isEditDocument(doc: ExpenseManagementLineDTO): boolean {
    let ret = false;

    if (!this.task?.work?.expenseManagementDTO?.context?.configurations['isVisibleExpenseDocumentForm']?.value) {
      return ret;
    }

    // TODO consultar atributo o gestionar en servidor. Se hace de esta manera porque se gestiona en n parche y queremos que el alcance sea lo menor posible
    if (doc?.isExpenseDocument && doc?.documentDTO?.currentState?.identifier === '50') {
      return ret;
    }

    if (doc.expenseTaskStatus === ExpenseTaskStates.PENDING || doc.expenseTaskStatus === ExpenseTaskStates.COMPLETED) {
      ret = true;
    }
    return ret;
  }

  isShowDocument(doc: ExpenseManagementLineDTO): boolean {
    let ret = false;
    if (doc.isExpenseDocument) {
      ret = true;
    }
    return ret;
  }

  isReversedDocument(doc: ExpenseManagementLineDTO): boolean {
    return doc.reversed;
  }

  reverseDocument() {
  }

  isNewDocument(doc: ExpenseManagementLineDTO): boolean {
    return doc.newExpenseDocument;
  }

  isDisabledEditDocument(doc: ExpenseManagementLineDTO): string {
    let ret = 'disabled';
    if (!this.task?.work?.expenseManagementDTO?.context?.configurations['isVisibleExpenseDocumentForm']?.value) {
      return ret;
    }

    if (doc.expenseTaskStatus === ExpenseTaskStates.PENDING || doc.expenseTaskStatus === ExpenseTaskStates.COMPLETED) {
      ret = '';
    }
    return ret;
  }

  isDisabledNewDocument(doc: ExpenseManagementLineDTO): string {
    let ret = 'disabled';
    if (doc.newExpenseDocument) {
      ret = '';
    }
    return ret;
  }

  isDisabledReverseDocument(doc: ExpenseManagementLineDTO): string {
    let ret = '';
    if (doc.reversed) {
      ret = 'disabled';
    }
    return ret;
  }

  protected cancelDocument(doc: ExpenseManagementLineDTO): void {
    let url = this.configuration.EXPENSE_DOCUMENT_EVENT_STATEDOCUMENT_URL.replace(
      '{expenseDocumentIdentifier}',
      doc.documentDTO.identifier
    );
    let cliente = this.appConfig.getValue('cliente');

    // TODO 'AYMAD'
    // cliente = 'AYMAD';
    if ('AYMAD' === cliente) {
      url = url.replace(
        '{eventId}',
        'PreCancelDocument'
      );
    } else {
      url = url.replace(
        '{eventId}',
        'CancelDocument'
      );
    }
    this.uiService.showConfirmMessage({
      message: this.translateService.instant('ExpenseManagement.actions.cancelDocument.message'),
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting(this.translateService.instant('General.infoUpdate'));
        this.subscribe(this.documentStateEvent(url)
          .pipe(
            catchError((error: any) => {
              console.error(error);
              let messgeError = 'Se ha producido un error al realizar la operación de anulación. Consultar con el administrador.';
              if (error && error.error && error.error.message != null) {
                messgeError = error.error.message;
              }
              this.uiService.showMessage(messgeError, 'Anulación de documento contable');
              return throwError(error);
            })
          ),
          (result) => {
            if (result && result.resultStateEvent) {
              this.taskLoad();
            }
          },
          () => undefined,
          () => {
            this.waitService.cancelWaiting();
          }
        );
      },
      reject: () => undefined
    });
  }

  taskLoad() {
    console.log('taskLoad: RECARGA LA TAREA DE GASTO DEL EXPEDIENTE: ', this.dossierId);
    let taskLoaded = false;
    this.waitService.startWaiting();
    this.subscribe(this.taskService.getTaskWithActions(this.task.identifier),
      (resultNewDocument) => {
        this.task = resultNewDocument;
        this.load(false);
      },
      (error) => {
        console.log('taskLoad: Se ha producido un error al recargar la tarea del gasto del expediente.' + error);
      })
    taskLoaded = true;
    this.waitService.cancelWaiting();
  }

  private documentStateEvent(url: string): Observable<any> {
    return this.plycaService.simpleUpdate(
      url,
      new Object()
    );
  }

  newDocument(doc: ExpenseManagementLineDTO) {
    this.subscribe(this.openAccountingDocumentTypeSelector(doc).onClose, (result: ExpenseDocumentLinkDTO) => {
      if (result) {
        // MODO MODAL
        this.subscribe(this.openAccountingDocumentEditorFromLink(doc, result).onClose, () => {
          console.log('RECARGA EL GASTO DEL EXPEDIENTE: newDocument', this.dossierId);
          this.waitService.startWaiting(this.translateService.instant('General.infoUpdate'));
          this.subscribe(this.taskService.getTaskForWork(this.task.identifier),
            (resultNewDocument) => {
              this.task = resultNewDocument;
              this.load();
            },
            (error) => {
              this.waitService.cancelWaiting();
              console.log('Se ha producido un error al recargar la tarea del gasto del expediente.' + error);
            })
        });
      }
    });
  }

  showDocument(doc: ExpenseManagementLineDTO) {
    this.subscribe(this.openShowAccountingDocumentEditorFromDocument(doc).onClose, (resulModal) => {
    });
  }

  openShowAccountingDocumentEditorFromDocument(document: ExpenseManagementLineDTO) {
    let config: DynamicDialogConfig = {
      header: 'Ver documento contable',
      width: '95%',
      style: { overflow: 'hidden' },
      styleClass: 'formEdition'
    };

    config['readOnly'] = true;
    config['id'] = document.documentDTO.entity.identifier;
    config['expenseManagementLine'] = document;
    config['divisionId'] = getSimpleIdentifierFromString(document.documentDTO.entity.division.identifier);

    return this.dialogService.open(AccountingDocumentComponent, config);
  }

  editDocument(doc: ExpenseManagementLineDTO) {
    this.subscribe(this.openAccountingDocumentEditorFromDocument(doc).onClose, (resulModal) => {
      if (resulModal) {
        console.log('RECARGA EL GASTO DEL EXPEDIENTE: editDOcument', this.dossierId);

        this.waitService.startWaiting(this.translateService.instant('General.infoUpdate'));
        this.subscribe(this.taskService.getTaskWithActions(this.task.identifier),
          (result) => {
            this.task = result;
            this.load();
          },
          (error) => {
            this.waitService.cancelWaiting();
            console.log('Se ha producido un error al recargar la tarea del gasto del expediente.' + error);
          })
      }
    });
  }

  openAccountingDocumentTypeSelector(doc: any) {
    let config: DynamicDialogConfig = {
      header: 'Seleccionar tipo de documento contable',
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '60vh' },
      styleClass: 'searchStyle'
    };
    config['task'] = this.task;
    config['origen'] = doc;
    return this.dialogService.open(AccountingDocumentTypesComponent, config);
  }

  openAccountingDocumentEditorFromDocument(document: ExpenseManagementLineDTO) {
    let config: DynamicDialogConfig = {
      header: 'Edición de documento contable',
      width: '95%',
      style: { overflow: 'hidden' },
      styleClass: 'formEdition'
    };
    config['task'] = this.task;
    config['id'] = document.documentDTO.entity.identifier;
    config['expenseManagementLine'] = document;
    config['divisionId'] = getSimpleIdentifierFromString(document.documentDTO.entity.division.identifier);

    return this.dialogService.open(AccountingDocumentComponent, config);
  }

  openAccountingDocumentEditorFromLink(origen: ExpenseManagementLineDTO, expenseDocumentLink: ExpenseDocumentLinkDTO) {
    let config: DynamicDialogConfig = {
      header: 'Nuevo documento contable',
      width: '95%',
      style: { overflow: 'hidden' },
      styleClass: 'formEdition'
    };
    // config['origen'] = doc;
    config['projectIdentifier'] = this.dossierId;
    config['divisionId'] = this.task.work.divisionIdentifier;
    config['documentClassId'] = expenseDocumentLink.childDocumentClass.identifier;
    config['sign'] = expenseDocumentLink.childSign;
    config['documentType'] = expenseDocumentLink.childExpenseDocumentType.documentType;
    config['task'] = this.task;
    config['parentDocumentIdentifier'] = origen.documentDTO.identifier;
    config['documentType'] = expenseDocumentLink.childExpenseDocumentType.documentType;
    // Es ncesario el siguiente parámetro porque un tipo de documento, por ejemplo que sea de futuro, puede estar en el mismo encadenamiento
    // para fututo y para tramitación anticipada
    config['exerciseClassification'] = expenseDocumentLink.exerciseClassification;

    return this.dialogService.open(AccountingDocumentComponent, config);
  }

  volver() {
    if (this.task) {
      let cliente = this.appConfig.getValue('cliente');
      // TODO 'AYMAD'
      // cliente = 'AYMAD';
      if ('AYMAD' === cliente) {
        this.confirmationIntegrationAYMAD();
      } else {
        this.processTask()
      }
    } else {
      this.uiService.routeBack()
    }
  }

  private confirmationIntegrationAYMAD(): void {
    // Solo se comunica con SAP cuando la tarea no es de validar y hay documentos contables pendientes, es decir, están en rojo!!
    this.processedTask = false;

    let pending = this.expenseLines && this.expenseLines.some(expenseLine =>
      expenseLine.expenseTaskStatus === ExpenseTaskStates.PENDING
      && expenseLine.isExpenseDocument
      && expenseLine.expenseDocument);

    let availableActions = this.expenseLines && this.expenseLines.some(expenseLine =>
      expenseLine.expenseTaskStatus === ExpenseTaskStates.PENDING
      && expenseLine.isExpenseDocument
      && expenseLine.expenseDocument
      && expenseLine.expenseDocument.availableActions);

    if (pending) {
      if (availableActions) {
        this.confirmationService.confirm({
          message: this.translateService.instant('¿Desea mandar la información generada en esta tarea a SAP para actualizar los datos?'),
          acceptLabel: this.translateService.instant('General.yes'),
          rejectLabel: this.translateService.instant('General.no'),
          accept: () => {
            this.subscribe(this.integrationWithStates().pipe(
              switchMap(success => {
                if (!success) {
                  this.validaCierreVentana = false;
                  this.uiService.routeBack();
                  return EMPTY;
                } else {
                  return this.processTaskObservable().pipe(
                    finalize(() => {
                      this.processedTask = true;
                      this.load();
                    })
                  )
                }
              })
            )
            )
          },
          reject: () => {
            this.validaCierreVentana = false;
            // Importante *******************************************************************************************
            //    - this.uiService.routeBack() termina invocando a TaskHandler.canDeactivate
            //    - No es necesario hacer un savework porque es reactivo!!, el work reacciona
            //      a los documentos contables (insert, update..)
            // ******************************************************************************************************
            this.uiService.routeBack();
          }
        });
      } else { // No hay acciones a ejecutar
        let dialogRef = this.uiService.showMessage('No hay acciones a ejecutar', 'Servicios con SAP', 'helpStyle'); // 'errorStyle');
        this.subscribe(dialogRef.onClose,
          () => {
            this.validaCierreVentana = false;
            this.uiService.routeBack();
          }
        );
      }
    } else if (pending) {
      this.validaCierreVentana = false;
      this.uiService.routeBack();
    } else {
      this.processTask();
    }
  }

  sortExpenseLines(expenseLine: ExpenseManagementLineDTO[]) {
    return expenseLine.sort((a, b) => {
      if (a.expenseDocument.orderNumber >= b.expenseDocument.orderNumber) {
        return 1;
      } else {
        return -1;
      }
    });
  }

  private integrationWithStates(): Observable<any> {
    if (this.expenseLines) {
      // Solo nos interesan los documentos contables que forman parte de la tarea y están pendientes.
      let filteredExpenseLines = this.expenseLines.filter(expenseLine =>
        expenseLine.expenseTaskStatus === ExpenseTaskStates.PENDING
        && expenseLine.isExpenseDocument
        && expenseLine.expenseDocument)

      if (filteredExpenseLines) {
        let actionsResults = new Array<ActionResultDTO>();
        this.sortExpenseLines(filteredExpenseLines);
        let observablefilteredExpenseLines: Observable<ActionResultDTO>[] = filteredExpenseLines.map(line => {
          return this.processExpenseDocument(line).pipe(
            catchError((error: any) => {
              // La ejecución de la acción devuelve un errror no controlado
              let errorDescription = this.plycaErrorHandler.getErrorMessage(error);
              let actionResultError = new ActionResultDTO();
              actionResultError.identifier = 'KO';
              actionResultError.description = 'Error no controlado por la acción: \n' + errorDescription;
              return of(actionResultError);
            }),
            tap((actionResult: ActionResultDTO) => {
              if (actionResult) {
                actionsResults.push(actionResult)
              }
            })
          );
        }
        );
        let processExpenseDocumentObs = concat(...observablefilteredExpenseLines).pipe(
          last(),
          switchMap((lastResult: ActionResultDTO) => {
            let errorStyle = false;
            let titleKeyInfo = false;
            let finalMessage = '';
            let titleKey: string;
            let styleClass: string;

            actionsResults.forEach(
              (actionResult: ActionResultDTO) => {
                // processExpenseDocument return of(undefined) cuando no es un documento contable o lo es pero no forma parte de la tarea
                if (actionResult !== undefined) {
                  let message: string;
                  if (actionResult.identifier === 'OK') {
                    if (actionResult.objectResult) {
                      errorStyle = true;
                      titleKeyInfo = true;
                      message = '<li>' + actionResult.objectResult
                        ? '\n' + JSON.stringify(actionResult.objectResult)
                        : '';
                    } else {
                      message = '<li>' + this.translate.instant('Actions.exec.ok');
                    }
                  } else {
                    errorStyle = true;
                    message = this.translate.instant('General.errorMessage');
                    if (actionResult.description) {
                      message = actionResult.description;
                    }
                    message = '<li>' + message
                  }
                  finalMessage = finalMessage + message;
                }
              }
            );
            titleKey = 'Sincronización con SAP';
            if (errorStyle) {
              styleClass = 'errorStyle';
            } else {
              styleClass = 'successStyle';
            }
            finalMessage = '<ul>' + finalMessage + '</ul>';
            this.waitService.cancelWaiting();
            let showContentRef = this.uiService.showContent(finalMessage, titleKey, styleClass);
            return showContentRef.onClose.pipe(
              tap(() => {
                if (!this.processedTask) {
                  this.waitService.startWaiting(this.translateService.instant('General.infoUpdate'));
                }
              }),
              map(() => {
                return !errorStyle;
              })
            );
          })
        );
        this.waitService.startWaiting('Sincronizando con SAP...');
        return processExpenseDocumentObs;
      }
    }
  }

  private processExpenseDocument(expenseLine: ExpenseManagementLineDTO): Observable<ActionResultDTO> {
    let availableActions: LinkedActionsDTO = expenseLine.expenseDocument.availableActions;
    if (availableActions?.actions) {
      let parameters: any;
      if (this.task && this.task.work && this.task.work.context && this.task.work.context.configurations
        && this.task.work.context.configurations['fechaRecepcion']) {
        parameters = 'FECHA_RECEPCION=' + this.task.work.context.configurations['fechaRecepcion'].value;
      }
      // TODO
      // **** ojo!! solo consideramos una acción!! *********************************************************************************
      let action = availableActions.actions[0];
      // Observable de observable hay que aplanarlo -> flatmap
      // *********************************************************************************
      let actionReturnObs: Observable<ActionResultDTO>
      actionReturnObs = this.plycaService.runActionLink(action, parameters);
      return actionReturnObs;
    } else {
      let actionResultError = new ActionResultDTO();
      actionResultError.identifier = 'KO';
      actionResultError.description = 'No hay acciones disponibles, por este motivo, no se informa a SAP';
      return of(actionResultError);
    }
  }
}
